import { useMutation, useQuery } from 'react-query';
import { HeadingPages } from '../../../components/HeadingPages';
import { useParams } from 'react-router-dom';
import { baseURL } from '../../../services/api';
import { Loader } from '../../../components/ComponentLoader/Loader';
import { Box, Button, Flex, Grid, Text, useToast } from '@chakra-ui/react';
import Input from '../CadastroProdutos/Input';
import Select from '../CadastroProdutos/Select';
import { ViewDescriptionModal } from '../CadastroProdutos/ViewDescriptionModal';
import { InputValueBRL } from '../CadastroProdutos/InputValueBRL';
import { ModalRegisterImpression } from '../CadastroProdutos/ModalRegisterImpressao';
import { ModalRegisterImages } from '../CadastroProdutos/ModalRegisterImages';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { schemaCompleteRegisterProduct } from '../CadastroProdutos/schema/schemaCompleteRegisterProduct';

async function getProductById(id) {
  try {
    const response = await baseURL.get(`/detalhes-produto/listar-info-produtos/${id}`);

    return response.data;
  } catch (err) {
    console.log('error', err);
    return null;
  }
}

export function FormEditarProduto() {
  const { id } = useParams();

  const {
    handleSubmit,
    register,
    control,
    setValue,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: zodResolver(schemaCompleteRegisterProduct)
  });

  const { data, isLoading, isError } = useQuery({
    queryKey: ['getProductByCategory', id],
    queryFn: () => getProductById(id),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24
  });

  const descriptionValue = useRef(data?.descricao_produto);

  const [description, setDescription] = useState(data?.descricao_produto);

  useEffect(() => {
    if (data) {
      setValue('referencia', data.referencia);
      setValue('descricao', data.descricao_produto);
      setValue('tagsSeo', data.ad_tagseo);
      setValue('tituloSeo', data.ad_titulo_seo);
      setValue('urlSeo', data.ad_urlseo);
      setValue('referenciaFornecedor', data.referencia_fornecedor);
      descriptionValue.current = data.descricao_produto;
      setDescription(data.descricao_produto);
      setValue('ativoSite', data.ad_ativosite);
      setValue('ativo', data.ativo);
      setValue('minPrazoEntrega', data.ad_minprazoentrega);
      setValue('minQtdSite', data.ad_minqtd_site);
      setValue('multiploProduto', data.ad_multiplo);
      setValue('pedidoMinimo', data.ad_pedidominimo);
      setValue('maxBatidas', data.ad_maxbatidas);
      setValue('pesoBruto', parseFloat(data.peso_bruto).toFixed(2));
      setValue('altura', parseFloat(data.altura).toFixed(2));
      setValue('largura', parseFloat(data.largura).toFixed(2));
      setValue('profundidade', parseFloat(data.espessura).toFixed(2));
      setValue('outrosCustos', data.ad_outroscustos);
      setValue('origemProduto', data.orig_prod);

      setValue('outrosCustos', data.ad_outroscustos);
    }
  }, [data, setValue]);

  const { mutateAsync } = useMutation(
    async (params) => {
      const response = await baseURL.put('/crm-produto/alterar-produto', params);

      return response.data;
    },
    {
      onSuccess: (data) => {
        openModal();
      }
    }
  );

  async function handleRegisterCompleteProduct(form) {
    const params = {
      codigo_produto: data?.codigo_produto,
      referencia: data?.referencia,
      origem_produto: form?.origemProduto,
      descricao_produto: descriptionValue?.current,
      altura: form?.altura.replace(',', '.'),
      largura: form?.largura.replace(',', '.'),
      espessura: form?.profundidade.replace(',', '.'),
      peso_bruto: form?.pesoBruto.replace(',', '.'),
      outros_custos: form?.outrosCustos,
      min_quantidade: form?.minQtdSite,
      max_batidas: form?.maxBatidas,
      min_prazo: form?.minPrazoEntrega,
      multiplo_produto: form?.multiploProduto,
      pedido_minimo: form?.pedidoMinimo,
      ativo_site: form?.ativoSite,
      ativo: form?.ativo,
      urlseo: form?.urlSeo,
      tagseo: form?.tagsSeo,
      tituloseo: form?.tituloSeo
    };

    console.log('resposta', params);

    await mutateAsync(params);
  }

  const multiploProduto = Array.from({ length: 10 }, (_, index) => ({
    name: `${index + 1}0`,
    value: (index + 1) * 10
  })).filter((item) => item.value === 10 || item.value === 50 || item.value === 100);

  const maxBatidas = Array.from({ length: 10 }, (_, index) => ({
    name: `${index + 1} Batidas`,
    value: index + 1
  }));

  const minPrazoEntrega = Array.from({ length: 10 }, (_, index) => ({
    name: `${index + 1} Dias`,
    value: index + 1
  }));

  const ativoSite = Array.from({ length: 2 }, (_, index) => ({
    name: index === 0 ? 'Sim' : 'Não',
    value: index === 0 ? 'S' : 'N'
  }));

  const listOrigem = [
    {
      value: 0,
      name: 'Nacional, exceto as indicadas nos código 3, 4, 5 e 8'
    },
    {
      value: 1,
      name: 'Estrangeira, importação direta, exceto a indicada no código 6'
    },
    {
      value: 2,
      name: 'Estrangeira, adquirida no mercado interno, exceto a indicada no código 7'
    },
    {
      value: 3,
      name: 'Nacional, mercadoria ou bem com conteúdo de importação superior a 40% e inferior  ou igual a 70%'
    },
    {
      value: 4,
      name: 'Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos'
    },
    {
      value: 5,
      name: 'Nacional, mercadoria ou bem com conteúdo de importação inferior ou igual a 40%'
    },
    {
      value: 6,
      name: 'Estrangeira, importação direta, sem similar nacional, constante em lista da CAMEX'
    },
    {
      value: 7,
      name: 'Estrangeira, adquirida no mercado interno, sem similar nacional, constante em lista da CAMEX'
    },
    {
      value: 8,
      name: 'Nacional, mercadoria ou bem Conteúdo de importação superior a 70%'
    }
  ];

  const [modalOpen, setModalOpen] = useState(false);
  const [modalDescriptionOpen, setModalDescriptionOpen] = useState(false);

  function openModal() {
    setModalOpen(true);
  }

  function closeModal() {
    setModalOpen(false);
  }

  function handleDescription(description) {
    descriptionValue.current = description;
  }

  function confirmDescription() {
    setValue('descricao', descriptionValue?.current);
    setModalDescriptionOpen(false);
  }

  useEffect(() => {
    setValue('descricao', descriptionValue?.current);
  }, [descriptionValue?.current]);

  const toast = useToast({
    position: 'top-right'
  });

  const camelCaseToWords = (str) => {
    const words = str.split(/(?=[A-Z])/);
    return words.join(' ');
  };

  useEffect(() => {
    if (errors) {
      Object.entries(errors).forEach(([fieldName, error]) => {
        toast({
          title: `Erro ao cadastrar produto no campo ${camelCaseToWords(fieldName)}`,
          description: error.message,
          status: 'error',
          duration: 3000,
          isClosable: true
        });
      });
    }
  }, [errors]);

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <div>Erro ao buscar produto</div>;
  }

  return (
    <>
      <HeadingPages name={`Editando produto - ${data?.descricao_produto}`} />

      <Box maxW="760px" w="full" mx="auto" display="flex" flexDir="column" mb="3rem">
        <Box
          display="flex"
          flexDir="column"
          gap=".7rem"
          mt="3rem"
          as="form"
          onSubmit={handleSubmit(handleRegisterCompleteProduct)}>
          <Text fontSize="16px">
            Codigo do produto: <strong>{data?.codigo_produto}</strong>
          </Text>

          <Flex gap="1">
            <Input
              name="referencia"
              label="Referencia"
              {...register('referencia')}
              error={errors.referencia?.message}
              width="225px"
              disabled
            />
            <Select
              name="origemProduto"
              label="Origem do produto"
              placeholder="Origem do produto"
              options={listOrigem}
              control={control}
              error={errors.origemProduto?.message}
            />
          </Flex>

          <ViewDescriptionModal
            error={errors.descricao?.message}
            description={descriptionValue}
            handleDescription={handleDescription}
            onOpen={() => setModalDescriptionOpen(true)}
            onClose={() => setModalDescriptionOpen(false)}
            isOpen={modalDescriptionOpen}
            onConfirm={confirmDescription}
          />
          <Grid gridGap="1" templateColumns="194px 159px 176px 1fr">
            <Input
              name="pesoBruto"
              label="Peso bruto"
              error={errors.pesoBruto?.message}
              {...register('pesoBruto')}
              rightAddon="Kg"
            />
            <Input
              name="altura"
              label="Altura"
              error={errors.altura?.message}
              {...register('altura')}
              rightAddon="Cm"
            />
            <Input
              name="largura"
              label="Largura"
              error={errors.largura?.message}
              {...register('largura')}
              rightAddon="Cm"
            />
            <Input
              name="profundidade"
              label="Profundidade"
              error={errors.profundidade?.message}
              {...register('profundidade')}
              rightAddon="Cm"
            />
          </Grid>
          <InputValueBRL control={control} error={errors.outrosCustos?.message} />
          <Grid gap="1" templateColumns="200px 250px 1fr">
            <Input
              name="minQtdSite"
              label="Min. Qtd. Site"
              {...register('minQtdSite')}
              error={errors.minQtdSite?.message}
            />
            <Select
              name="maxBatidas"
              label="Max. Batidas"
              options={maxBatidas}
              control={control}
              error={errors.maxBatidas?.message}
            />
            <Select
              name="minPrazoEntrega"
              label="Min. Prazo Produção"
              options={minPrazoEntrega}
              control={control}
              error={errors.minPrazoEntrega?.message}
            />
          </Grid>

          <Flex gap="75px">
            <Select
              name="multiploProduto"
              label="Múltiplo do produto"
              options={multiploProduto}
              control={control}
              error={errors.multiploProduto?.message}
              placeholder="Selecione"
            />
            <Input
              name="pedidoMinimo"
              label="Pedido mínimo"
              type="number"
              {...register('pedidoMinimo')}
              error={errors.pedidoMinimo?.message}
            />
          </Flex>
          <Input
            name="tagsSeo"
            label="TAG SEO KEY WORDS"
            type="text"
            {...register('tagsSeo')}
            error={errors.tagsSeo?.message}
            labelWidth="200px"
          />
          <Input
            name="tituloSeo"
            label="Título SEO"
            type="text"
            {...register('tituloSeo')}
            error={errors.tituloSeo?.message}
            labelWidth="200px"
          />
          <Input
            name="urlSeo"
            label="URL SEO"
            type="text"
            {...register('urlSeo')}
            error={errors.urlSeo?.message}
            labelWidth="200px"
          />

          <Flex gap="1">
            <Select
              name="ativo"
              label="Ativo"
              options={ativoSite}
              control={control}
              placeholder="Ativo"
              error={errors.ativo?.message}
            />
            <Select
              name="ativoSite"
              label="Ativo Site"
              options={ativoSite}
              control={control}
              placeholder="Ativo Site"
              error={errors.ativoSite?.message}
            />
          </Flex>

          <Flex maxW="300px">
            {/* <SelectImpressaoPopover
              control={control}
              error={errors.tipoImpressao?.message}
              setImpSelected={setImpSelected}
              impSelected={impSelected}
              codGrupoProd={data?.codigo_grupo_produto}
            /> */}

            <ModalRegisterImpression data={data} />
          </Flex>

          <ModalRegisterImages
            openModal={openModal}
            closeModal={closeModal}
            isOpen={modalOpen}
            codProduto={data?.codigo_produto}
          />
          <Button
            textTransform="uppercase"
            fontSize="20px"
            maxW="295px"
            w="full"
            mx="auto"
            rounded="full"
            bgColor="#378BBF"
            color="#fff"
            fontWeight="normal"
            _hover={{
              filter: 'brightness(0.9)'
            }}
            type="submit"
            disabled={isSubmitting}
            isLoading={isSubmitting}>
            Salvar
          </Button>
        </Box>
      </Box>
    </>
  );
}
